import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJavascriptComponent } from './simple-icons-javascript.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJavascriptComponent ],
    exports:      [ SimpleIconsJavascriptComponent ],
    bootstrap:    []
})
export class SimpleIconsJavascriptModule {}
